<script setup lang="ts">
import BaseOverlay from '@/overlays/BaseOverlay.vue';
import { eventBus } from '@/utils/eventBus';

interface Props {
  title: string;
  duration?: number;
}

withDefaults(defineProps<Props>(), {
  duration: 3000,
});

const closeAllOverlays = () => {
  eventBus.emit('triggerClose');
};
</script>

<template>
  <BaseOverlay @close="closeAllOverlays" :duration="duration">
    <template #content>
      <div class="h-max bg-neutral-100 px-20 pt-48">
        <div class="h-max flex items-center justify-center flex-col">
          <div
            class="icon-background mb-12 flex items-center justify-center rounded-full bg-green-400"
          >
            <fa-icon :icon="['fas', 'check']" class="icon text-neutral-0" />
          </div>
          <p class="h1000">
            {{ title }}
          </p>
        </div>
      </div>
    </template>
  </BaseOverlay>
</template>

<style lang="scss" scoped>
.icon-background {
  width: 220px;
  height: 220px;
}

.icon {
  font-size: 100px;
}
</style>
